import DetailsViewPageContainer from 'components/DetailsViewPageContainer';

import useData from './hooks/useData';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const CreateBoundaryPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const {
        geometry,
        handleClose,
        handleEditMapClose,
        handleMapComplete,
        mapInteractionOptions,
        mapOptions
    } = useData();

    return (
        <DetailsViewPageContainer
            geometry={geometry}
            handleClose={handleClose}
            handleEditMapClose={handleEditMapClose}
            handleMapComplete={handleMapComplete}
            hasDrawingControls
            mapInteractionOptions={mapInteractionOptions}
            mapOptions={mapOptions}
            testId={testId}
        />
    );
};

export default CreateBoundaryPage;
